/**
 * Save a server-authored file byte-for-byte — no BOM, unlike `downloadCSV`.
 * `fileName` needs its extension; same-frame revoke can cancel the download.
 */
export const downloadBlob = (fileName: string, blob: Blob) => {
  const blobURL = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(blobURL), 1000);
};

export const downloadCSV = (fileName: string, content: string) => {
  // Prepend a UTF-8 BOM so Excel renders non-ASCII characters (diacritics in
  // subject/site names) correctly instead of mojibake.
  const csvData = new Blob(['\uFEFF', content], {
    type: 'text/csv;charset=utf-8;',
  });
  const csvURL = URL.createObjectURL(csvData);
  const link = document.createElement('a');
  link.href = csvURL;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
